import React from 'react';
import ReactDOM from 'react-dom/client';
import { RehubSupabaseTracking } from '@rehub/tracking/react';
import App from './App';
import { supabase } from './services/supabase';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
    <RehubSupabaseTracking app="sketchplan" mode="events-only" supabase={supabase} />
  </React.StrictMode>
);